export const NOTIFICATION_TYPE = {
  CAN_RECEIVE_SMS: 'canReceiveSms',
  CAN_RECEIVE_OPPORTUNITY_EMAILS: 'canReceiveOpportunityEmails',
  CAN_RECEIVE_RESERVATION_NOTIFICATION_EMAILS: 'canReceiveReservationNotificationEmails',
  CAN_RECEIVE_ROSTER_NOTIFICATIONS: 'canReceiveRosterNotifications',
  CAN_RECEIVE_CHANGELOG_EMAILS: 'canReceiveChangelogEmails',
  CAN_RECEIVE_DIGEST_EMAILS: 'canReceiveDigestEmails',
  CAN_RECEIVE_NO_PRICING_OPTION_RESERVATION_EMAILS: 'canReceiveNoPricingOptionReservationEmails',
  CAN_RECEIVE_ATTENDANCE_INQUIRY_EMAILS: 'canReceiveAttendanceInquiryEmails',
};

export const NOTIFICATION_TYPE_LIST = Object.values(NOTIFICATION_TYPE);
